/**
 * Este selector pretende abarcar todos modificadores que en caso de estar
 * presentes hacen que un elemento no sea focusable
 */
export const cantFocusSelector = [
  '[disabled]',
  '[tabIndex="-1"]',
  '[aria-hidden="true"]',
  '[data-focus-guard]',
  '.modal__closeButton',
]
  .map((current) => `:not(${current})`)
  .join('');

/**
 * Este selector pretende abarcar todos los elementos que sean focusables
 */
export const focusSelector = [
  'input',
  'textarea',
  'select',
  'a',
  'button:not(.toggleAccordionElement)',
  '[contenteditable]',
  '[tabIndex]',
  '[role="button"]',
]
  .map((current) => `${current}${cantFocusSelector}`)
  .join(',');

/**
 * Genera un selector que permitirá seleccionar
 * todos los elementos candidatos a recibir foco,
 * que no cumplan con la condición not pasada
 * como parámetro.
 *
 * @param not Un selector not css, indicando cuáles
 * condiciones deben evitar el foco en un elemento.
 *
 * @returns Una cadena que representa un selector
 * css.
 */
export function getFocusSelector(not?: string) {
  return `input${not ?? ''}, 
    textarea${not ?? ''}, 
    select${not ?? ''}, 
    a${not ?? ''}, 
    button:not(.toggleAccordionElement)${not ?? ''}, 
    [contenteditable]${not ?? ''}, 
    [tabIndex]${not ?? ''}`;
}
